'use strict';

/** @type {import('./uri')} */
module.exports = URIError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/uri.js
// module id = 385
// module chunks = 0